import { useContext, useEffect, useState } from "react";
import styles from "./searchFilter.module.css";
import { arrow_stroke } from "../../assets/icons";
import { OptionDt } from "../../Models/SearchModel";
import { SearchContext } from "../../Store/Search.store";

export default function AlternativeToFilter( {filterItems, callBack}: {filterItems: OptionDt[], callBack: (filter: OptionDt[], filterOrder: number) => void} ) {
    const { searchData, setSearchData} = useContext(SearchContext);
    const [expanded, setExpanded] = useState(false);
    const [filterItemsState, setFilterItemsState] = useState(filterItems);

    useEffect(() => {
        setFilterItemsState(filterItems);
    }, [filterItems]);

    useEffect(() => {
        if(searchData.openFilter === 1){
            setExpanded(true);
        } else {
            setExpanded(false);
        }
    }, [searchData.openFilter]);

    const handleFilterChange = (id: number) => {
        const newFilterState = filterItemsState.map(item =>
            item.id === id ? { ...item, isSelected: !item.isSelected } : item
        );
        
        setSearchData(prevState => ({
            ...prevState,
            data: {
                ...prevState.data,
                filters: {
                    ...prevState.data.filters,
                    alternativeToCategories: newFilterState
                }
            }
        }));

        callBack(newFilterState.filter(item => item.isSelected), 1);
    }
    return (
        <div className={`${styles.filter_container} filter`}>
            <button className={`${styles.filter} ${expanded ? styles.expanded : ""}`} aria-controls="alternativeto_hidden" aria-expanded={expanded} onClick={() => expanded ? setSearchData({...searchData, openFilter: 0}) : setSearchData({...searchData, openFilter: 1})}>
                <span>Alternative to</span>
                {arrow_stroke}
            </button>
            <div className={`${styles.expanded_content} ${expanded ? styles.expanded : ""}`} id="alternativeto_hidden">
                {/* <label htmlFor={filterName + "_search"} className={styles.hidden}>search for {filterName}</label>
                <input name={filterName + "_search"} id={filterName + "_search"} type="text" /> */}
                <div className={styles.filter_items}>
                    {filterItemsState?.map((item, index) => (
                        <div key={index} className={styles.filter_item}>
                        <input type="checkbox" id={item.name + item.id} name={item.name + item.id} value={item.id}  checked={item.isSelected} onChange={() => handleFilterChange(item.id)} disabled={item.hits == 0}/>
                        <label htmlFor={item.name + item.id}>{item.name}</label>
                        <span>({item.hits != undefined ? item.hits : 0})</span>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
}